<template>
    <list route-name="tests-stat.show" :user-id="currentUserId" />
</template>

<script>

import List from './../Users/Tests/Index/List'
import { mapGetters } from 'vuex'

export default {
    components: { List },
    computed: {
        ...mapGetters({
            currentUserId: 'e/users/currentUserId'
        })
    }
}
</script>
